/**
 * Mobile app distribution config.
 *
 * Reads the SSR-injected `window.__MOBILE_APP_CONFIG__` blob (see
 * `api/config/urls.py:_inject_mobile_config`). The landing-page "Get the app"
 * section uses it to flip between a direct APK download (pre-launch) and store
 * badges (once published). The values are env-controlled on the backend
 * (`MOBILE_ANDROID_PUBLISHED` / `MOBILE_IOS_PUBLISHED`).
 *
 * The landing page is always server-rendered via `spa_index`, so the global is
 * present on first paint — a synchronous read with a safe default is enough; no
 * network round-trip required.
 */

export interface MobileAppConfig {
	androidPublished: boolean;
	iosPublished: boolean;
	storeUrlAndroid: string;
	storeUrlIos: string;
	/** Unauthenticated endpoint that streams the active Android APK. */
	androidDownloadUrl: string;
}

const SAFE_DEFAULT: MobileAppConfig = {
	androidPublished: false,
	iosPublished: false,
	storeUrlAndroid: "",
	storeUrlIos: "",
	androidDownloadUrl: "/mobile/releases/android/app-release.apk",
};

export function readBootstrappedMobileConfig(): Partial<MobileAppConfig> | null {
	if (typeof window === "undefined") return null;
	const bootstrap = (
		window as unknown as { __MOBILE_APP_CONFIG__?: Partial<MobileAppConfig> }
	).__MOBILE_APP_CONFIG__;
	return bootstrap ?? null;
}

export function useMobileAppConfig(): MobileAppConfig {
	return { ...SAFE_DEFAULT, ...(readBootstrappedMobileConfig() ?? {}) };
}
